// extracted by mini-css-extract-plugin
export var button = "_e9-4";
export var hasDarkBackground = "_e9-7";
export var hasLightBackground = "_e9-6";
export var iconWrapper = "_e9-0";
export var large = "_e9-2";
export var medium = "_e9-1";
export var small = "_e9-5";
export var xsmall = "_e9-3";